import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';

import { AppRoutingModule, ROUTING_COMPONENTS } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InicioModule } from './modulos/inicio.module';
import { AppMaterialModule } from './shared/material/app-material.module';

@NgModule({
  declarations: [
    AppComponent,
    ROUTING_COMPONENTS,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AppMaterialModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      closeButton: true,
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'increasing'
    }),
    InicioModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
